// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBuhAZ-d3lTncdgYt88y_kVzvtPdPQ67ho",
    authDomain: "shiftdevapp-default-rtdb.firebaseio.com/",
    databaseURL: "https://shiftdevapp-default-rtdb.firebaseio.com/",
    projectId: "shiftdevapp",
    storageBucket: "shiftdevapp.appspot.com",
    messagingSenderId: "931483852849"
  },
  membership:{
    premium: "premium",
    basic: "basic",
    pending: "pending"
  },
  serverKey : 'AAAA2ODDoDE:APA91bHYdE5n7SOqUMseKvoRtKS3QrWXaaOW8grKzWsKOmfyV9cBbHWBI6sxWtN50oKl-8VZuBCAAjtKChXCrnmX9w5URCezi9gGB51oHagITdWVvAgAKgiDP9XC4tBhuyAsEQ7El1-s'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
